"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.age = void 0;
const date_fns_1 = require("date-fns");
/**
 * Given a Date or an ISO string date, the age will be returned relative to today's date
 * @param dob - ISO format string YYYY-MM-DD
 * @returns the age as a number with 2 floating points at the most, can be -1 for invalid dates
 */
function age(dob, decimals = false) {
    if (typeof dob === 'string') {
        dob = (0, date_fns_1.parseISO)(dob);
    }
    if ((0, date_fns_1.isValid)(dob)) {
        const today = new Date();
        const duration = (0, date_fns_1.intervalToDuration)({ start: dob, end: today });
        if (decimals) {
            return parseFloat(((duration.years || 0) + (duration.months || 0) / 12).toFixed(2));
        }
        else {
            return duration.years || 0;
        }
    }
    else {
        return -1;
    }
}
exports.age = age;
